// extracted by mini-css-extract-plugin
export var grid = "fp-wD";
export var gridWithRowGap = "fp-xD";
export var maxWidthContainer = "fp-BD";
export var mt0 = "fp-oD";
export var mt1 = "fp-pD";
export var mt2 = "fp-qD";
export var mt3 = "fp-rD";
export var mt4 = "fp-sD";
export var mt5 = "fp-tD";
export var mt6 = "fp-uD";
export var removeVisuallyHidden = "fp-zD";
export var tooltip = "fp-CD";
export var tooltip__content = "fp-ED";
export var tooltip__trigger = "fp-DD";
export var tooltip__triggerButton = "fp-vD";
export var visuallyHidden = "fp-yD";
export var widgetBase = "fp-AD";